export class UpdateExtraUsersDataQuery {
    constructor(private readonly screen_data) {}

     execute(kind: string, value: number) {
        const item = this.screen_data[kind];
        if (!item || !item.show) return;

        if (item.selected_extra_users == null) {
            item.selected_extra_users = item.paid_extra_users ?? 0;
        }

        const delta = value - item.selected_extra_users; 
        const total = item.selected_extra_users + delta;
        if (total < item.extra_users_num || total < 0) return;
        
        if (item.extra_users_num > 0 && item.extra_users_num >= total) {
            item.validation_error = 'Para renovar con una cantidad menor de usuarios adicionales, debe desactivar previamente tantos usuarios como desee eliminar.';
        } else {
            item.validation_error = null;
        }
        item.selected_extra_users = total;

    }
}